/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';

export default (connectionSalesTypes) => ({
    type: actions.CONNECTION_SALES_TYPES_RECEIVE,
    payload: { connectionSalesTypes },
});